import { Component } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

@Component({
	selector: 'app-core-quote-review-result-modal',
	templateUrl: './core-quote-review-result-modal.component.html'
})
export class CoreQuoteReviewResultModalComponent extends UIModalBaseComponent {

	quoteId;
	newStage = '';
	notes = '';
	disabled = false;
	approveBlocked: string = null;

	record = {
		id: 0,
		quote_date: null,
		expiry_date: null
	};

	constructor(
		private app: AppService,
		private api: ApiService
	) {
		super();
	}

	open(mdata: any) {
		this.quoteId = mdata.id;
		this.approveBlocked = mdata.approveBlocked || null;
		this.newStage = '';
		this.notes = '';
		this.modal.open();
	}

	submitResult() {
		this.disabled = true;

		const data = { id: this.quoteId, stage: this.newStage, notes: this.notes };

		this.api.quote.submitReviewResult(data, () => {
			this.disabled = false;
			this.app.quotePriceChange.emit();
			this.app.quoteStageChange.emit();
			this.modal.close(true);
		}, error => {
			this.disabled = false;

			// Required work outstanding on the deal: this closes so the global checkpoint isn't stacked on it
			if (this.app.requiredWork.hold(error, () => this.finishResult(data))) {
				this.modal.close();
				return;
			}

			this.app.notifications.showDanger(error.message);
		});

	}

	// The result the checkpoint held, sent again after Continue
	private finishResult(data) {
		this.api.quote.submitReviewResult(data, () => {
			this.app.quotePriceChange.emit();
			this.app.quoteStageChange.emit();
		}, error => {
			if (this.app.requiredWork.hold(error, () => this.finishResult(data))) return;
			this.app.notifications.showDanger(error.message);

			// Reopened as it was, so the reviewer's notes aren't lost
			this.open({ id: data.id, approveBlocked: this.approveBlocked });
			this.newStage = data.stage;
			this.notes = data.notes;
		});
	}

}
